export default "__VITE_ASSET__B$cjRIv___"